import { useEffect, useRef } from 'react';

/**
 * This effect won't trigger the first render - only when
 * something changes with the dependencies.
 * @param fn
 * @param deps
 */
const useEffectOnChange = (effect: React.EffectCallback, deps?: React.DependencyList) => {
  const r = useRef<any>();
  useEffect(() => {
    if (r.current) {
      return effect();
    } else {
      r.current = true;
    }
  }, deps);
};
export default useEffectOnChange;